const REQUEST_MONITOR_OVERALL_STATS = 'platfi-ui-app/MONITOR/REQUEST_MONITOR_OVERALL_STATS';
const REQUEST_MONITOR_OVERALL_STATS_SUCCESS =
  'platfi-ui-app/MONITOR/REQUEST_MONITOR_OVERALL_STATS_SUCCESS';
const REQUEST_MONITOR_OVERALL_STATS_FAILURE =
  'platfi-ui-app/MONITOR/REQUEST_MONITOR_OVERALL_STATS_FAILURE';

export {
  REQUEST_MONITOR_OVERALL_STATS,
  REQUEST_MONITOR_OVERALL_STATS_SUCCESS,
  REQUEST_MONITOR_OVERALL_STATS_FAILURE,
};
